import { CSSProperties } from 'react';
import { getTaxonomyColor, useEntityIcon } from '@agilelab/plugin-wb-platform';
import { Box, makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';

type EntityIconProps = {
  useCaseTemplateId: string;
  kind: string;
  title: string;
  taxonomyUrn?: string;
  style?: CSSProperties;
  className?: string;
  disableSystemForceDefault?: boolean;
};

const useStyles = makeStyles<Theme, { taxonomyId: string }>(
  theme => ({
    root: {
      width: '20px',
      height: '20px',
      overflow: 'hidden',
    },
    img: {
      width: '100%',
      height: '100%',
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
    },
    taxonomyColor: props => ({
      color: getTaxonomyColor(props.taxonomyId, theme),
    }),
  }),
  { name: 'EntityIcon' },
);

export const EntityIcon = ({
  useCaseTemplateId,
  kind,
  title,
  taxonomyUrn,
  className,
  style,
  disableSystemForceDefault,
}: EntityIconProps) => {
  const classes = useStyles({ taxonomyId: taxonomyUrn ?? '' });
  const { getIcon, loading } = useEntityIcon();

  const icon = getIcon(useCaseTemplateId, kind, disableSystemForceDefault);

  const getIconElement = () => {
    if (loading || icon === undefined) return null;
    if (icon.type === 'img')
      return (
        <div
          className={classes.img}
          style={{ backgroundImage: `url(${icon.src})` }}
          role="img"
          aria-label={title}
        />
      );
    return (
      <div className={classes.img}>
        <icon.icon />
      </div>
    );
  };

  return (
    <Box
      className={clsx(classes.root, classes.taxonomyColor, className)}
      style={style}
    >
      {getIconElement()}
    </Box>
  );
};
